import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-angle-up",
  "use": "icon-cl-angle-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-cl-angle-up\"><path d=\"M7.247 3.86a1 1 0 0 1 1.506 0l4.796 5.482c.566.646.106 1.658-.753 1.658H3.204c-.86 0-1.319-1.012-.753-1.659l4.796-5.48Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol